class ComparativoAnualChart {
    formatValue(values) {
        return values
            .map(item => item === null ? 'null': item)
            .join()
    }

    hasKeys(data) {
        return data && Object.keys(data).length
    }
}

angular.module('eficienciaFiscalModule')
    .component('comparativoAnualChart', {
        controller: [ComparativoAnualChart],
        bindings: {
            id: '<',
            data: '<',
            labels: '<',
            name: '@',
            format: '<',
            yLabel: '@'
        },
        template: `
        <div class="row">
            <div class="col-xs-12">
                <div class="comparativo-chart">
                    <highlighted ng-if="!$ctrl.hasKeys($ctrl.data)">
                        <main>{{$ctrl.name}}</main>
                        <secondary>Não há dados suficientes neste período</secondary>
                    </highlighted>

                    <div ng-if="$ctrl.hasKeys($ctrl.data)">
                        <h1 class="text-center" ng-if="$ctrl.name">{{$ctrl.name}}</h1>
                        <c3chart bindto-id="{{$ctrl.id}}">
                            <chart-column column-id="x"
                                column-values="{{$ctrl.labels.join()}}"/>
                            <chart-column 
                                ng-repeat="(key, values) in $ctrl.data" 
                                column-id="{{key}}"
                                column-values="{{$ctrl.formatValue(values)}}"
                                column-type="spline"/>
                            <chart-axes values-x="x" y="{{Object.keys($ctrl.data).join()}}"/>
                            <chart-axis>
                                <chart-axis-y axis-id="y" axis-position="outer-right" axis-label="{{$ctrl.yLabel}}">
                                    <chart-axis-y-tick tick-format-function="$ctrl.format"/>
                                </chart-axis-y>
                                <chart-axis-x axis-position="outer-center" axis-type="category"></chart-axis-x>
                            </chart-axis>
                        </c3chart>
                    </div>
                </div>
            </div>
        </div>
        `
    })